import React from 'react'
import Container from './View'

// This will render MissionData which is the next data source needed
// Which will then render the view component
export const EditMissionDetails = props => {
  return (
    <Container
      {...props}
      //missionId={props.match.params.missionId}
      //cityPlanId={props.match.params.cityPlanId}
    />
  )
}
